import { ROLES } from 'config';
import template from './settings.html';
import './settings.styl';

function settingsComponent($rootScope, $tszToast, AuthService, UserService, CompanyService) {

  'ngInject';

  this.roles = ROLES;

  this.companyId = AuthService.getCompanyId();

  this.user = AuthService.getAuthenticatedUser();

  this.invite = (userEmail) => {
    const invitation = {
      email: userEmail,
      companyId: this.companyId,
    };
    CompanyService.invite(this.companyId, invitation)
    .then(() => {
      $tszToast.showSuccess(`Se enviado una invitación al correo electrónico ${userEmail}`);
      $rootScope.$broadcast('reloadCompanyUsers', this.user.companyId);
    }).catch(() => {
      $tszToast.showError(`No se ha podido enviar la invitación a ${userEmail}`);
    });
  };

  this.showCompanySettings = () => AuthService.isUser();
  this.showTeamSettings = () => AuthService.isUser() && AuthService.hasEnterprisePlan();

}

export default {
  template,
  controller: settingsComponent,
};



// WEBPACK FOOTER //
// ./src/containers/settings/index.js